// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-summary-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  font-family: "Syne", sans-serif;
  width: 100vw;
  box-sizing: border-box;
}

.profile-summary-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeInUp 0.8s ease-out;
  padding: 0 1rem;
  box-sizing: border-box;
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 1rem;
  width: 100%;
  max-width: 600px;
}

.summary-avatar {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  padding: 15px;
  box-shadow: 0 15px 35px rgba(102, 22, 205, 0.2);
  margin-bottom: 1.5rem;
  animation: avatarFloat 3s ease-in-out infinite;
}

.avatar-message h2 {
  color: #6616cd;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(102, 22, 205, 0.1);
}

.avatar-message p {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 400;
}

.profile-details-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f0f0f0;
  flex-wrap: wrap;
  gap: 1rem;
}

.card-header h3 {
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.user-type-badge {
  background: linear-gradient(135deg, #6616cd, #8b5cf6);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.profile-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.detail-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-group label {
  font-weight: 600;
  color: #6616cd;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  min-height: 60px;
}

.detail-value:hover {
  border-color: #6616cd;
  background: #f5f3ff;
}

.detail-value span {
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  word-break: break-word;
  flex: 1 1;
  margin-right: 1rem;
}

.edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  opacity: 0.6;
  flex-shrink: 0;
}

.edit-btn:hover {
  background: #6616cd;
  opacity: 1;
  transform: scale(1.1);
}

.interests-section {
  position: relative;
}

.interests-section:hover .interests-list {
  border-color: #6616cd;
  background: #f5f3ff;
}

.interests-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.interests-header label {
  font-weight: 600;
  color: #6616cd;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.interests-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  background: #f8f9fa;
  border-radius: 12px;
  min-height: 60px;
  align-items: flex-start;
  align-content: flex-start;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  cursor: pointer;
}

.interests-list:hover {
  border-color: #6616cd;
  background: #f5f3ff;
}

.interest-tag {
  background: linear-gradient(135deg, #6616cd, #8b5cf6);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  display: inline-block;
  animation: tagFadeIn 0.3s ease-out;
  transition: transform 0.2s ease;
  white-space: nowrap;
}

.interest-tag:hover {
  transform: scale(1.05);
}

.no-interests {
  color: #999;
  font-style: italic;
  align-self: center;
  width: 100%;
  text-align: center;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.edit-profile-btn,
.edit-interests-btn {
  flex: 1 1;
  min-width: 140px;
  max-width: 200px;
  padding: 0.75rem 1.5rem;
  border: 2px solid #6616cd;
  background: transparent;
  color: #6616cd;
  border-radius: 12px;
  font-family: "Syne", sans-serif;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.edit-profile-btn:hover,
.edit-interests-btn:hover {
  background: #6616cd;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 22, 205, 0.3);
}

.start-matching-btn {
  flex: 2 1;
  min-width: 200px;
  max-width: 300px;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #6616cd, #8b5cf6);
  color: white;
  border: none;
  border-radius: 12px;
  font-family: "Syne", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;
}

.start-matching-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.4);
}

.start-matching-btn.starting {
  background: linear-gradient(135deg, #8b5cf6, #6616cd);
  cursor: not-allowed;
}

.heart-icon {
  font-size: 1.2rem;
  animation: heartBeat 1.5s ease-in-out infinite;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes avatarFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes heartBeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes tagFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .profile-summary-container {
    max-width: 900px;
  }
  
  .profile-details-card {
    max-width: 700px;
  }
}

@media (max-width: 768px) {
  .profile-summary-page {
    padding: 1rem;
  }

  .profile-summary-container {
    padding: 0 0.5rem;
  }

  .profile-details-card {
    padding: 2rem;
    max-width: 100%;
  }

  .card-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }

  .edit-profile-btn,
  .edit-interests-btn,
  .start-matching-btn {
    flex: none;
    width: 100%;
    max-width: 300px;
  }

  .avatar-message h2 {
    font-size: 1.5rem;
  }

  .avatar-message p {
    font-size: 1rem;
  }

  .detail-value {
    align-items: flex-start;
    gap: 0.5rem;
  }

  .detail-value span {
    margin-right: 0;
  }

  .edit-btn {
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .profile-summary-page {
    padding: 0.5rem;
  }

  .profile-summary-container {
    padding: 0;
  }

  .profile-details-card {
    padding: 1.5rem;
    border-radius: 15px;
  }

  .summary-avatar {
    width: 100px;
    height: 100px;
  }

  .detail-value {
    padding: 0.75rem 1rem;
    min-height: 50px;
  }

  .interests-list {
    padding: 1rem;
  }

  .avatar-message h2 {
    font-size: 1.3rem;
  }

  .avatar-message p {
    font-size: 0.9rem;
  }

  .card-header h3 {
    font-size: 1.3rem;
  }

  .action-buttons {
    gap: 0.75rem;
  }

  .edit-profile-btn,
  .edit-interests-btn,
  .start-matching-btn {
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 360px) {
  .profile-details-card {
    padding: 1rem;
  }

  .summary-avatar {
    width: 80px;
    height: 80px;
  }

  .avatar-message h2 {
    font-size: 1.2rem;
  }

  .avatar-message p {
    font-size: 0.85rem;
  }

  .detail-value {
    padding: 0.5rem 0.75rem;
  }

  .interests-list {
    padding: 0.75rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ProfileSummary/ProfileSummary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;;IAGE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".profile-summary-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  font-family: \"Syne\", sans-serif;\n  width: 100vw;\n  box-sizing: border-box;\n}\n\n.profile-summary-container {\n  width: 100%;\n  max-width: 1200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  animation: fadeInUp 0.8s ease-out;\n  padding: 0 1rem;\n  box-sizing: border-box;\n}\n\n.avatar-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  max-width: 600px;\n}\n\n.summary-avatar {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 15px;\n  box-shadow: 0 15px 35px rgba(102, 22, 205, 0.2);\n  margin-bottom: 1.5rem;\n  animation: avatarFloat 3s ease-in-out infinite;\n}\n\n.avatar-message h2 {\n  color: #6616cd;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(102, 22, 205, 0.1);\n}\n\n.avatar-message p {\n  color: #666;\n  font-size: 1.1rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n.profile-details-card {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 20px;\n  padding: 2.5rem;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 100%;\n  max-width: 800px;\n  box-sizing: border-box;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #f0f0f0;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.card-header h3 {\n  color: #333;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.user-type-badge {\n  background: linear-gradient(135deg, #6616cd, #8b5cf6);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.profile-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.detail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.detail-group label {\n  font-weight: 600;\n  color: #6616cd;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-value {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  min-height: 60px;\n}\n\n.detail-value:hover {\n  border-color: #6616cd;\n  background: #f5f3ff;\n}\n\n.detail-value span {\n  color: #333;\n  font-size: 1rem;\n  font-weight: 500;\n  word-break: break-word;\n  flex: 1;\n  margin-right: 1rem;\n}\n\n.edit-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n.edit-btn:hover {\n  background: #6616cd;\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.interests-section {\n  position: relative;\n}\n\n.interests-section:hover .interests-list {\n  border-color: #6616cd;\n  background: #f5f3ff;\n}\n\n.interests-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.interests-header label {\n  font-weight: 600;\n  color: #6616cd;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.interests-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 12px;\n  min-height: 60px;\n  align-items: flex-start;\n  align-content: flex-start;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.interests-list:hover {\n  border-color: #6616cd;\n  background: #f5f3ff;\n}\n\n.interest-tag {\n  background: linear-gradient(135deg, #6616cd, #8b5cf6);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: inline-block;\n  animation: tagFadeIn 0.3s ease-out;\n  transition: transform 0.2s ease;\n  white-space: nowrap;\n}\n\n.interest-tag:hover {\n  transform: scale(1.05);\n}\n\n.no-interests {\n  color: #999;\n  font-style: italic;\n  align-self: center;\n  width: 100%;\n  text-align: center;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.edit-profile-btn,\n.edit-interests-btn {\n  flex: 1;\n  min-width: 140px;\n  max-width: 200px;\n  padding: 0.75rem 1.5rem;\n  border: 2px solid #6616cd;\n  background: transparent;\n  color: #6616cd;\n  border-radius: 12px;\n  font-family: \"Syne\", sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.edit-profile-btn:hover,\n.edit-interests-btn:hover {\n  background: #6616cd;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 22, 205, 0.3);\n}\n\n.start-matching-btn {\n  flex: 2;\n  min-width: 200px;\n  max-width: 300px;\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #6616cd, #8b5cf6);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Syne\", sans-serif;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.start-matching-btn:hover:not(:disabled) {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.4);\n}\n\n.start-matching-btn.starting {\n  background: linear-gradient(135deg, #8b5cf6, #6616cd);\n  cursor: not-allowed;\n}\n\n.heart-icon {\n  font-size: 1.2rem;\n  animation: heartBeat 1.5s ease-in-out infinite;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes avatarFloat {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes heartBeat {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes tagFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .profile-summary-container {\n    max-width: 900px;\n  }\n  \n  .profile-details-card {\n    max-width: 700px;\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-summary-page {\n    padding: 1rem;\n  }\n\n  .profile-summary-container {\n    padding: 0 0.5rem;\n  }\n\n  .profile-details-card {\n    padding: 2rem;\n    max-width: 100%;\n  }\n\n  .card-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .edit-profile-btn,\n  .edit-interests-btn,\n  .start-matching-btn {\n    flex: none;\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .avatar-message h2 {\n    font-size: 1.5rem;\n  }\n\n  .avatar-message p {\n    font-size: 1rem;\n  }\n\n  .detail-value {\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .detail-value span {\n    margin-right: 0;\n  }\n\n  .edit-btn {\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-summary-page {\n    padding: 0.5rem;\n  }\n\n  .profile-summary-container {\n    padding: 0;\n  }\n\n  .profile-details-card {\n    padding: 1.5rem;\n    border-radius: 15px;\n  }\n\n  .summary-avatar {\n    width: 100px;\n    height: 100px;\n  }\n\n  .detail-value {\n    padding: 0.75rem 1rem;\n    min-height: 50px;\n  }\n\n  .interests-list {\n    padding: 1rem;\n  }\n\n  .avatar-message h2 {\n    font-size: 1.3rem;\n  }\n\n  .avatar-message p {\n    font-size: 0.9rem;\n  }\n\n  .card-header h3 {\n    font-size: 1.3rem;\n  }\n\n  .action-buttons {\n    gap: 0.75rem;\n  }\n\n  .edit-profile-btn,\n  .edit-interests-btn,\n  .start-matching-btn {\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 360px) {\n  .profile-details-card {\n    padding: 1rem;\n  }\n\n  .summary-avatar {\n    width: 80px;\n    height: 80px;\n  }\n\n  .avatar-message h2 {\n    font-size: 1.2rem;\n  }\n\n  .avatar-message p {\n    font-size: 0.85rem;\n  }\n\n  .detail-value {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .interests-list {\n    padding: 0.75rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
